export const FIRST_THUMBNAIL_LIST_COUNT_DESKTOP = 9
export const FIRST_THUMBNAIL_LIST_COUNT_MOBILE = 4
export const FIRST_THUMBNAIL_LIST_COUNT_DESKTOP_WITH_PM_FEED = 6
export const SECOND_THUMBNAIL_LIST_COUNT_DESKTOP = 6
export const SECOND_THUMBNAIL_LIST_COUNT_MOBILE = 4
export const NUM_OF_PM_ARTICLES = 3
